import { useState, useEffect } from "react"
import axios from "axios"

const useFetch = (config) => {
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState([])
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true)
                setIsError(false)
                const myResponse = await axios(config)
                const esito = myResponse.data.esito
                if (esito === "OK") {
                    const prodotti = myResponse.data
                    setData(prodotti)
                    setIsLoading(false)
                } else if (esito === "KO") {

                    setIsLoading(false)
                } else {
                    return []
                }
            } catch (error) {
                console.log(error)
                setIsError(true)
            }
        })()
    }, [])

    return { isLoading, data, isError }
}
export default useFetch